'use client';

import { useSyncExternalStore } from 'react';

import { resolveLink, resolveLinkUntracked } from '@/sanity/globals/CTA';

const subscribe = () => () => {};

export function useTrackedLink(link: string | undefined, language: string): string | undefined {
  const hydrated = useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
  if (!link) return undefined;
  return hydrated ? resolveLink(link, language) : resolveLinkUntracked(link, language);
}
